import { useTranslation } from 'react-i18next'

import { QA_NAME_MODAL_RESIZE_BTN } from '../../../constants/qa'
import Button from '../../Button'

import { TOOLTIP_DISMISS_PARAMS } from './ModalResizeButton.constants'

import CollapseIcon from '../../../icons/collapse.svg'
import ExpandIcon from '../../../icons/expand.svg'

function ModalResizeButton({ isFullScreen, ...restProps }) {
  const { t } = useTranslation()

  const buttonTooltipText = isFullScreen
    ? 'Modal.ResizeExitFullScreenBtnTooltipKey'
    : 'Modal.ResizeFullScreenBtnTooltipKey'

  return (
    <Button.Text
      {...restProps}
      isGrey
      beforeIconProps={{ Icon: isFullScreen ? CollapseIcon : ExpandIcon }}
      qaName={QA_NAME_MODAL_RESIZE_BTN}
      tooltip={t(buttonTooltipText)}
      tooltipDismissParams={TOOLTIP_DISMISS_PARAMS}
    />
  )
}

export default ModalResizeButton
